import { render, staticRenderFns } from "./VipInfo.vue?vue&type=template&id=4268db4c&scoped=true&"
import script from "./VipInfo.vue?vue&type=script&lang=js&"
export * from "./VipInfo.vue?vue&type=script&lang=js&"
import style0 from "./VipInfo.vue?vue&type=style&index=0&id=4268db4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268db4c",
  null
  
)

export default component.exports